import { render } from "./CreateServiceModal.vue?vue&type=template&id=f4275d0c"
import script from "./CreateServiceModal.vue?vue&type=script&lang=js"
export * from "./CreateServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__